<template>
  <!-- Real widget reuse: same CustomMultiSelect dropdown as every other filter (MultiSelectFilter.vue)
       instead of a plain native <select> — a native select rendered visually different from the
       collapsed-dropdown-with-ticks look shared by the rest of the sidebar. Single-select mode
       (no `multiple`): picking SI/NO replaces the previous choice; "Tutti" is the unset state,
       reachable via the clear-selection "x" (single-select toggle can't deselect by re-clicking). -->
  <custom-multi-select
    :options="booleanOptions"
    :value="checkedValues"
    :default-text="$t('search.booleanAny')"
    use-ticks
    show-clear-selection
    maintain-original-order
    @input="onInput"
  ></custom-multi-select>
</template>

<script>
import CustomMultiSelect from '../../Lib/CustomMultiSelect'

// Generic Boolean filter, tri-state: unset (not applied) / true / false.
export default {
  name: 'booleanFilter',
  components: { CustomMultiSelect },
  props: {
    filterKey: { type: String, required: true },
    value: { type: Boolean, default: null },
  },
  computed: {
    booleanOptions() {
      return [
        { value: 'true', text: this.$t('search.booleanTrue') },
        { value: 'false', text: this.$t('search.booleanFalse') },
      ]
    },
    checkedValues() {
      if (this.value === true) return ['true']
      if (this.value === false) return ['false']
      return []
    },
  },
  methods: {
    onInput(selected) {
      if (selected.length === 0) {
        this.$emit('input', null)
        return
      }
      this.$emit('input', selected[0] === 'true')
    },
  },
}
</script>
